import {jwtDecode} from 'jwt-decode';
import {refresh_token} from '../actions/auth'

const API_URL = process.env.REACT_APP_API_URL;
export const PROJECTS_ENDPOINT = `${API_URL}/api/projects/projects/`;
export const PUBLIC_PROJECTS_ENDPOINT = `${API_URL}/api/projects/public_projects/`;
export const PUBLIC_PROJECTS_DETAIL_ENDPOINT = (projectId) => `${API_URL}/api/projects/public_projects/${projectId}/`;
export const REVIEW_PROJECTS_ENDPOINT = `${API_URL}/api/projects/review_projects/`;
export const PROJECT_DETAIL_ENDPOINT = (projectId) => `${API_URL}/api/projects/projects/${projectId}/`;
export const REVIEW_PROJECT_DETAIL_ENDPOINT = (projectId) => `${API_URL}/api/projects/review_projects/${projectId}/`;
export const USER_PROJECTS_ENDPOINT = `${API_URL}/api/projects/user_projects/`;
export const USER_SEARCH_ENDPOINT = (value) => `${API_URL}/api/auth/user-search?partial_name=${value}/`;
export const VENUES_ENDPOINT = `${API_URL}/api/workshops/venues/`;
export const VENUE_DETAIL_ENDPOINT = (venueId) => `${API_URL}/api/workshops/venues/${venueId}/`;
export const LOCAL_WORKSHOP_ENDPOINT = `${API_URL}/api/workshops/local_workshops/`;
export const LOCAL_WORKSHOP_DETAIL_ENDPOINT = (localWorkshopId) => `${API_URL}/api/workshops/local_workshops/${localWorkshopId}/`;
export const USER_LOCAL_WORKSHOP_ENDPOINT = `${API_URL}/api/workshops/user_local_workshops/`;
export const STREAMS_ENDPOINT = `${API_URL}/api/streams/streams/`;
export const STREAM_DETAIL_ENDPOINT = (streamId) => `${API_URL}/api/streams/streams/${streamId}/`;
export const LOCAL_STREAM_ENDPOINT = `${API_URL}/api/streams/local_streams/`;
export const LOCAL_STREAM_DETAIL_ENDPOINT = (localStreamId) => `${API_URL}/api/streams/local_streams/${localStreamId}/`;
export const USER_LOCAL_STREAM_ENDPOINT = `${API_URL}/api/streams/user_local_streams/`;
export const KEYWORDS_ENDPOINT = `${API_URL}/api/projects/keywords/`;

export const JWT_CREATE_ENDPOINT = `${API_URL}/api/auth/jwt/create/`;
export const JWT_REFRESH_ENDPOINT = `${API_URL}/api/auth/jwt/refresh/`;
export const JWT_VERIFY_ENDPOINT = `${API_URL}/api/auth/jwt/verify/`;

export const ALL_USERS_ENDPOINT = `${API_URL}/api/auth/all_users/`;
export const USER_DETAIL_ENDPOINT = (userId) => `${API_URL}/api/auth/all_users/${userId}/`;
export const AUTH_SIGNUP_ENDPOINT = `${API_URL}/api/auth/users/`;
export const AUTH_ACTIVATION_ENDPOINT = `${API_URL}/api/auth/users/activation/`;
export const AUTH_RESET_PASSWORD_ENDPOINT = `${API_URL}/api/auth/users/reset_password/`;
export const AUTH_RESET_PASSWORD_CONFIRM_ENDPOINT = `${API_URL}/api/auth/users/reset_password_confirm/`;
export const AUTH_LOAD_CURRENT_USER_ENDPOINT = `${API_URL}/api/auth/users/me/`;

function token_needs_refresh() {
    try {
        const decodedToken = jwtDecode(localStorage.getItem('access'));
        const currentTime = Date.now() / 1000;
        if (decodedToken.exp <= currentTime) {
            return true;
        }
    } catch (error) {
        console.error("Ошибка при декодировании JWT:", error);
        return false;
    }
    return false;
}


export const getJSONAcceptAuthConfig = () => {
    if (token_needs_refresh()) {
        refresh_token();
    }
    return {
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${localStorage.getItem('access')}`,
            'Accept': 'application/json'
        }
    };
}

export const getAcceptAuthConfig = () => {
    if (token_needs_refresh()) {
        refresh_token();
    }
    return {
        headers: {
            'Authorization': `Bearer ${localStorage.getItem('access')}`,
        }
    };
}


export const getJSONAcceptConfig = () => {
    return {
        headers: {
            'Content-Type': 'application/json', 'Accept': 'application/json'
        }
    };
}

export const getJSONConfig = () => {
    return {
        headers: {
            'Content-Type': 'application/json'
        }
    };
}